export default "__VITE_ASSET__nJThjf2Z__"